import { useEffect, useState } from "react";
import Hero from "@/components/organisms/Hero";
import TabItems from "@/components/molecules/TabItems";
import RoomsCard from "@/components/organisms/RoomsCard";

const TabRooms = ({ t, rooms, from, priceNight, ...props }) => {
  const [active, setActive] = useState(0);
  const [filterRooms, setFilterRoom] = useState(rooms);
  const columns = [6, 6, 4, 4, 4, 6, 6, 4, 4, 4, 6, 6];

  const onSelect = (key) => {
    setActive(key);
    if (filters[key]?.tabs === "all") {
      setFilterRoom(rooms);
    } else {
      setFilterRoom(
        rooms.filter(
          (room) =>
            room.room_category.id === filters[key]?.tabs ||
            room?.view?.toLowerCase() === filters[key]?.tab.toLowerCase()
        )
      );
    }
  };
  const filters =
    props?.filters && Array.isArray(props?.filters) ? props?.filters : false;

  const styles = {
    section: props?.classes?.section || "py-12",
    container: props?.classes?.container || "base-container pb-6",

    filters: props?.classes?.filters || {
      tabContainer: "flex justify-center",
      active: " text-main-blue font-semibold  md:mx-3 basis-1/3",
      inactive: "text-medium-grey hover:text-main-blue-king md:mx-3 basis-1/3",
      tab: "font-subtitle text-sm lg:text-lg uppercase mb-10 break-word",
    },
  };

  useEffect(() => {
    setActive("all");
    setFilterRoom(rooms);
  }, [rooms]);

  return (
    <section className="bg-main-blue-light pb-16">
      <div className="base-container my-14 ">
        <Hero
          title={{
            text: t("rooms:rooms_details.title"),
            className: "hero-title text-center text-[30px] lg:text-[50px]",
          }}
          text={{
            text: t("rooms:rooms_details.subtitle"),
            className: "section-subtitle text-center uppercase",
          }}
          styles={{
            heroContainer: "base-container pt-12 pb-3",
            titleContainer: "order-2 col-span-12 md:col-start-2 md:col-span-10",
            textContainer: "order-1 col-span-12 md:col-start-2 md:col-span-10",
          }}
        />
      </div>
      <div className="mx-auto max-w-6xl">
        <div className="base-container">
          <TabItems
            tabs={filters}
            onSelect={onSelect}
            classes={styles?.filters}
            active={active}
          />
        </div>

        <div className="base-grid gap-6 px-4">
          {filterRooms &&
            filterRooms.map((room, key) => {
              return (
                <RoomsCard
                  key={key}
                  room={room}
                  t={t}
                  columns={columns[key]}
                  className={`col-span-12 md:col-start-3 md:col-span-8 lg:col-span-${columns[key]}`}
                  from={from}
                  priceNight={priceNight}
                />
              );
            })}
        </div>
      </div>
    </section>
  );
};
export default TabRooms;
